<template>
    <el-dropdown class="setting-icon">
        <div class="btn cursor-pointer">A</div>
        <el-dropdown-menu slot="dropdown" class="w40">
            <div
                v-for="item in fontSizeList"
                :key="item"
                class="font-set-item"
                :style="{fontSize: `${item}px`}"
                @click="handleChangeSize(item)"
            >A</div>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
export default {
    props: {
        changeSize: Function
    },
    data() {
        return {
            fontSizeList: [14, 12]
        };
    },
    methods: {
        handleChangeSize(size) {
            this.changeSize(size === 14);
        }
    }
};
</script>

<style lang="scss" scoped>
.setting-icon {
    display: inline-block;
    margin-left: 8px;
    vertical-align: middle;
    .btn {
        font-size: 16px;
        border: 1px solid black;
        border-radius: 2px;
        height: 20px;
        width: 20px;
        line-height: 20px;
        text-align: center;
    }
}
.el-dropdown-menu {
    padding: 4px 0;
}
.font-set-item {
    cursor: pointer;
    display: inline-block;
    padding: 0 8px;
}
</style>
